import Vue from 'vue'
import Router from 'vue-router'

import { checkSystemLocked } from '../api'
import Login from '../views/Login/index.vue'
import VisitorInput from '../views/VisitorInput/index.vue'
import VisitorList from '../views/VisitorList/index.vue'
import TicketVerify from '../views/TicketVerify/index.vue'
import Finance from '../views/Finance/index.vue'
import DataManage from '../views/DataManage/index.vue'
import SystemSettings from '../views/SystemSettings/index.vue'
import SystemLocked from '../views/SystemLocked/index.vue'

Vue.use(Router)

const AUTH_KEY = 'yy_auth'

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { public: true }
    },
    {
      path: '/',
      redirect: '/visitor-input'
    },
    {
      path: '/visitor-input',
      name: 'VisitorInput',
      component: VisitorInput
    },
    {
      path: '/visitor-list',
      name: 'VisitorList',
      component: VisitorList
    },
    {
      path: '/ticket-verify',
      name: 'TicketVerify',
      component: TicketVerify
    },
    {
      path: '/finance',
      name: 'Finance',
      component: Finance
    },
    {
      path: '/data-manage',
      name: 'DataManage',
      component: DataManage
    },
    {
      path: '/system-settings',
      name: 'SystemSettings',
      component: SystemSettings
    },
    {
      path: '/locked',
      name: 'SystemLocked',
      component: SystemLocked,
      meta: { public: true }
    }
  ]
})

function getRole() {
  try {
    const raw = localStorage.getItem(AUTH_KEY)
    const auth = raw ? JSON.parse(raw) : null
    const user = auth && auth.user ? auth.user : null
    return (user && user.role) || ''
  } catch (e) {
    return ''
  }
}

function roleAllowedPaths(role) {
  const map = {
    '超级管理员': ['/visitor-input', '/visitor-list', '/ticket-verify', '/finance', '/data-manage', '/system-settings'],
    '游客录入员': ['/visitor-input', '/visitor-list', '/system-settings'],
    '票务核销员': ['/ticket-verify', '/system-settings'],
    '财务人员': ['/finance', '/data-manage', '/system-settings'],
    '分销商': ['/visitor-input', '/visitor-list', '/system-settings']
  }
  return map[role] || []
}

function defaultHomeByRole(role) {
  const map = {
    '超级管理员': '/visitor-input',
    '游客录入员': '/visitor-input',
    '票务核销员': '/ticket-verify',
    '财务人员': '/finance',
    '分销商': '/visitor-input'
  }
  return map[role] || '/login'
}

router.beforeEach(async (to, from, next) => {
  // public 页面不需要登录
  if (to.meta && to.meta.public) return next()

  // 检查系统是否被锁定（只检查一次，缓存到 sessionStorage）
  const lockedKey = 'system_locked_checked'
  let isLocked = sessionStorage.getItem(lockedKey) === 'true'

  if (!isLocked) {
    try {
      const result = await checkSystemLocked()
      if (result.locked) {
        isLocked = true
        sessionStorage.setItem(lockedKey, 'true')
      } else {
        // 检查通过，缓存结果一段时间（5分钟）
        sessionStorage.setItem(lockedKey, 'false')
        setTimeout(() => sessionStorage.removeItem(lockedKey), 5 * 60 * 1000)
      }
    } catch (e) {
      console.error('检查系统锁定状态失败:', e)
    }
  }

  // 如果系统被锁定，跳转到锁定页面
  if (isLocked && to.path !== '/locked') {
    return next({ path: '/locked' })
  }

  // 如果在锁定页面且系统未锁定，返回首页
  if (to.path === '/locked' && !isLocked) {
    sessionStorage.removeItem(lockedKey)
    return next({ path: '/' })
  }

  let authed = false
  try {
    const raw = localStorage.getItem(AUTH_KEY)
    authed = !!raw && !!JSON.parse(raw).token
  } catch (e) {
    authed = false
  }

  if (!authed) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }

  const role = getRole()
  const allowed = roleAllowedPaths(role)

  // 未识别角色：强制退出
  if (!role) {
    localStorage.removeItem(AUTH_KEY)
    return next('/login')
  }

  // 根路径按角色跳转
  if (to.path === '/') {
    return next(defaultHomeByRole(role))
  }

  // 角色无权访问
  const ok = allowed.some(p => to.path === p || to.path.startsWith(p + '/'))
  if (!ok) {
    return next(defaultHomeByRole(role))
  }

  next()
})

export default router
